/**
 * Zoy Reviews Slider
 * - Desktop: prev/next arrows + animated progress bar
 * - Mobile: swipe/touch + progress bar only (no arrows)
 */
function initZoyReviews(sectionId, cardsPerView) {
  const section     = document.querySelector('.section-' + sectionId);
  if (!section) return;

  const track       = section.querySelector('#zr-track-' + sectionId);
  const slides      = section.querySelectorAll('.zr-slide');
  const prevBtn     = section.querySelector('#zr-prev-' + sectionId);
  const nextBtn     = section.querySelector('#zr-next-' + sectionId);
  const progressBar = section.querySelector('#zr-progress-' + sectionId);

  if (!track || slides.length === 0) return;

  let current    = 0;
  let startX     = 0;
  let isDragging = false;
  const total    = slides.length;
  const gap      = 16;

  function getPerView() {
    if (window.innerWidth <= 480) return 1;
    if (window.innerWidth <= 767) return 1;
    if (window.innerWidth <= 1024) return Math.min(2, cardsPerView);
    return cardsPerView;
  }

  function getMaxIndex() {
    return Math.max(0, total - getPerView());
  }

  function updateProgress(idx, maxIdx) {
    if (!progressBar) return;
    const pct = maxIdx === 0 ? 100 : ((idx + getPerView()) / total) * 100;
    progressBar.style.width = Math.min(100, pct) + '%';
  }

  function goTo(idx) {
    const maxIndex = getMaxIndex();
    current = Math.max(0, Math.min(idx, maxIndex));

    const slideWidth = slides[0].offsetWidth;
    track.style.transform = 'translateX(-' + (current * (slideWidth + gap)) + 'px)';

    updateProgress(current, maxIndex);

    if (prevBtn) prevBtn.disabled = current === 0;
    if (nextBtn) nextBtn.disabled = current >= maxIndex;
  }

  // Arrow clicks
  if (prevBtn) prevBtn.addEventListener('click', () => goTo(current - 1));
  if (nextBtn) nextBtn.addEventListener('click', () => goTo(current + 1));

  // Touch swipe
  track.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
    isDragging = true;
  }, { passive: true });

  track.addEventListener('touchend', (e) => {
    if (!isDragging) return;
    const diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) goTo(diff > 0 ? current + 1 : current - 1);
    isDragging = false;
  }, { passive: true });

  // Mouse drag
  track.addEventListener('mousedown', (e) => { startX = e.clientX; isDragging = true; });
  window.addEventListener('mouseup', (e) => {
    if (!isDragging) return;
    const diff = startX - e.clientX;
    if (Math.abs(diff) > 40) goTo(diff > 0 ? current + 1 : current - 1);
    isDragging = false;
  });

  // Init & resize
  goTo(0);
  window.addEventListener('resize', () => goTo(Math.min(current, getMaxIndex())));
}

/* ── Self-initialize every reviews section (robust to load order / AJAX) ── */
(function () {
  function initAll() {
    document.querySelectorAll('[data-zoy-reviews]').forEach(function (el) {
      if (el.dataset.zoyReviewsInit) return;
      el.dataset.zoyReviewsInit = '1';
      var id = el.getAttribute('data-section-id');
      var per = parseInt(el.getAttribute('data-cards-per-view'), 10) || 3;
      try { initZoyReviews(id, per); } catch (e) { /* fail silently */ }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Theme editor re-renders
  document.addEventListener('shopify:section:load', initAll);
})();
